import React from 'react';
import Certifications from '../components/Certifications';

const CertificationsPage = () => {
  return <Certifications />;
};

export default CertificationsPage;

